module.exports = __webpack_public_path__ + "static/listingDash-4adce8ef4c297367b79e1091f1379c20.png";